import type { Post } from "@/types/content";

export const postsPart3: Post[] = [
  {
    id: "post-11",
    slug: "taipei-tarot-reading-top6",
    title: "台北塔羅推薦 TOP 6｜靠譜又不推銷的塔羅師評比",
    excerpt: "塔羅市場魚龍混雜，有的說準、有的亂說、有的想盡辦法賣你課程。神秘客走訪台北 16 間塔羅工作室，篩選出 6 間真正靠譜、不推銷的塔羅師。",
    coverImage: "https://readdy.ai/api/search-image?query=Mystical%20tarot%20card%20reading%20session%20with%20beautiful%20tarot%20deck%20candles%20and%20crystals%20on%20wooden%20table%20intimate%20spiritual%20atmosphere%20soft%20warm%20lighting%20simple%20background%20photography&width=1200&height=630&seq=111&orientation=landscape",
    category: "塔羅",
    tags: ["台北", "塔羅", "塔羅牌", "占卜", "身心靈", "推薦"],
    author: {
      id: "author-3",
      name: "神秘客A",
      avatar: "https://readdy.ai/api/search-image?query=Asian%20woman%20with%20glasses%20portrait%20professional%20clean%20white%20background%20headshot&width=100&height=100&seq=203&orientation=squarish",
      bio: "資深美業神秘客，專精美容保養與外貌美化類評測，涵蓋美甲、美睫、霧眉、采耳、除毛與做臉等項目。擁有 5 年神秘客資歷，累積評測店家超過 120 間。善於從細節觀察服務品質，特別關注衛生標準與長期效果。堅持匿名探訪，幫助消費者找到最適合自己的美業選擇。",
    },
    publishedAt: "2025-04-22",
    readingTime: 8,
    rating: 4.6,
    reviewCount: 97,
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>塔羅牌解讀是一種很個人化的服務，「好的塔羅師」其實包含很多面向——不只是說得準，更在於是否讓你帶著清晰感和行動力離開，而不是帶著更多焦慮。</p><p>神秘客走訪台北 16 間塔羅工作室，每次我們都帶著相似的問題去測試，觀察塔羅師的解讀方式、有沒有過度渲染負面、有沒有推銷額外課程或靈性商品。</p>",
      },
      {
        _type: "featureList",
        _key: "criteria",
        title: "評比標準",
        features: [
          { _key: "c1", icon: "ri-heart-line", title: "解讀品質", description: "是否能具體說明牌意與情境，而非模糊泛泛的說詞" },
          { _key: "c2", icon: "ri-shield-check-line", title: "不恐嚇不推銷", description: "是否過度放大負面牌義製造焦慮，或強推課程、商品" },
          { _key: "c3", icon: "ri-chat-3-line", title: "溝通與傾聽", description: "是否真的在乎你的問題，還是照表演出走流程" },
        ],
      },
      {
        _type: "cta",
        _key: "cta",
        title: "看更多塔羅師評比",
        subtitle: "神秘客實測台北塔羅工作室，公正評比解讀品質與誠信度",
        buttonLabel: "查看塔羅評比",
        buttonHref: "#",
      },
    ],
    seo: {
      title: "台北塔羅推薦 TOP 6｜不推銷靠譜塔羅師評比",
      description: "台北塔羅評比！神秘客走訪 16 間工作室，精選 6 間解讀準確、不恐嚇不推銷的塔羅師。",
      keywords: ["台北塔羅", "塔羅推薦", "塔羅師", "占卜推薦", "身心靈"],
    },
  },
  {
    id: "post-12",
    slug: "taiwan-astrology-guide",
    title: "星盤解讀懶人包｜第一次看星盤該找誰、問什麼",
    excerpt: "星盤解讀越來越受台灣年輕人歡迎，但看不懂的術語和眾多流派讓初學者無從下手。這篇教你星盤基礎知識，以及如何選到適合自己的星盤老師。",
    coverImage: "https://readdy.ai/api/search-image?query=Astrology%20natal%20chart%20with%20planets%20and%20zodiac%20symbols%20star%20map%20on%20dark%20blue%20background%20mystical%20spiritual%20atmosphere%20warm%20candlelight%20simple%20background%20photography&width=1200&height=630&seq=112&orientation=landscape",
    category: "星盤",
    tags: ["星盤", "占星", "身心靈", "自我探索", "懶人包", "推薦"],
    author: {
      id: "author-2",
      name: "Chen 神秘客",
      avatar: "https://readdy.ai/api/search-image?query=Young%20asian%20man%20portrait%20confident%20smile%20clean%20white%20background%20professional%20headshot&width=100&height=100&seq=202&orientation=squarish",
      bio: "資深美業神秘客，專精美髮造型與頭皮護理類評測。走訪台灣超過 80 間美髮沙龍、頭皮護理中心與越式洗髮店，對於設計師技術、護理產品成分與頭皮檢測儀器有深入研究。堅持匿名探訪，給讀者最直白的消費建議。",
    },
    publishedAt: "2025-04-08",
    readingTime: 9,
    rating: 4.5,
    reviewCount: 74,
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>星盤解讀（本命盤、流年盤）是近年最受台灣年輕人歡迎的身心靈服務之一。不同於塔羅的直覺式解讀，占星是有系統的符號語言，解讀的深度和廣度都很大，一次深度解讀可以帶來非常豐富的自我認識。</p><p>但第一次去看星盤的人常常搞不清楚：我應該問什麼？哪些老師比較靠譜？為什麼有人說得天花亂墜但內容空洞？這篇幫你建立基本概念。</p>",
      },
      {
        _type: "featureList",
        _key: "basics",
        title: "星盤基礎知識",
        features: [
          { _key: "b1", icon: "ri-sun-line", title: "太陽星座（月份）", description: "你最熟悉的星座就是太陽星座，代表你的核心自我與人生目標方向" },
          { _key: "b2", icon: "ri-moon-line", title: "月亮星座", description: "情緒模式與內在需求。你私下的樣子和面對壓力時的本能反應" },
          { _key: "b3", icon: "ri-arrow-right-circle-line", title: "上升星座", description: "你給人的第一印象，以及你面對世界的方式。很多人說上升比太陽更準就是這個原因" },
        ],
      },
      {
        _type: "cta",
        _key: "cta",
        title: "看更多占星評比",
        subtitle: "美好時光指南收錄台灣靠譜占星師評比，幫你找到有學問的解讀者",
        buttonLabel: "查看占星師評比",
        buttonHref: "#",
      },
    ],
    seo: {
      title: "星盤解讀懶人包｜第一次看星盤完整攻略",
      description: "星盤入門指南！太陽月亮上升三大重點解析，教你如何選靠譜占星師，第一次看星盤不踩雷。",
      keywords: ["星盤解讀", "占星推薦", "本命盤", "星座分析", "身心靈"],
    },
  },
  {
    id: "post-13",
    slug: "taipei-scalp-care-top6",
    title: "台北頭皮護理推薦 TOP 6｜掉髮、油頭、敏感頭皮全評比",
    excerpt: "頭皮是頭髮的土壤，護理好頭皮才能有健康的頭髮。神秘客走訪台北 16 間頭皮護理工作室，針對掉髮、出油、敏感三大問題族群分別推薦。",
    coverImage: "https://readdy.ai/api/search-image?query=Professional%20scalp%20care%20treatment%20with%20specialized%20equipment%20hair%20and%20scalp%20analysis%20clinic%20clean%20modern%20interior%20soft%20lighting%20simple%20background%20photography&width=1200&height=630&seq=113&orientation=landscape",
    category: "頭皮護理",
    tags: ["台北", "頭皮護理", "掉髮", "頭皮保養", "美髮", "懶人包", "推薦"],
    author: {
      id: "author-2",
      name: "Chen 神秘客",
      avatar: "https://readdy.ai/api/search-image?query=Young%20asian%20man%20portrait%20confident%20smile%20clean%20white%20background%20professional%20headshot&width=100&height=100&seq=202&orientation=squarish",
      bio: "資深美業神秘客，專精美髮造型與頭皮護理類評測。走訪台灣超過 80 間美髮沙龍、頭皮護理中心與越式洗髮店，對於設計師技術、護理產品成分與頭皮檢測儀器有深入研究。堅持匿名探訪，給讀者最直白的消費建議。",
    },
    publishedAt: "2025-05-08",
    readingTime: 10,
    rating: 4.7,
    reviewCount: 118,
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>頭皮護理是台灣美業中成長最快的項目之一。隨著都市壓力增加、熬夜習慣普遍，掉髮、頭皮出油、頭皮敏感的問題困擾越來越多人。</p><p>但頭皮護理市場水準差異極大——有些店家只是幫你洗頭順便推產品，有些則有真正的頭皮分析儀器和針對性的療程。神秘客走訪 16 間，幫你找出真正有效的選擇。</p>",
      },
      {
        _type: "featureList",
        _key: "types",
        title: "三大頭皮問題族群推薦",
        features: [
          { _key: "t1", icon: "ri-drop-line", title: "頭皮出油族", description: "選擇有控油深層清潔療程的工作室。關鍵是清潔後的保濕，只去油不保濕會讓頭皮分泌更多油脂" },
          { _key: "t2", icon: "ri-plant-line", title: "掉髮困擾族", description: "建議找有頭皮顯微鏡檢測的工作室。先確認是哪種掉髮（壓力性、雄性禿、頭皮炎等）才能對症下藥" },
          { _key: "t3", icon: "ri-alert-line", title: "頭皮敏感族", description: "選擇無香料、無酒精的溫和產品線，師傅操作應輕柔。先告知過敏史，讓師傅客製療程" },
        ],
      },
      {
        _type: "cta",
        _key: "cta",
        title: "看更多頭皮護理評比",
        subtitle: "神秘客實測台北頭皮護理工作室，公正評比療程效果與服務品質",
        buttonLabel: "查看頭皮護理評比",
        buttonHref: "#",
      },
    ],
    seo: {
      title: "台北頭皮護理推薦 TOP 6｜掉髮油頭敏感頭皮評比",
      description: "台北頭皮護理評比！神秘客走訪 16 間，針對掉髮、出油、敏感分別推薦最有效的工作室。",
      keywords: ["台北頭皮護理", "頭皮保養", "掉髮治療", "頭皮護理推薦"],
    },
  },
  {
    id: "post-14",
    slug: "maya-calendar-reading-guide",
    title: "馬雅圖騰印記懶人包｜你的生命密碼藏在出生日期裡",
    excerpt: "馬雅曆法圖騰是近年台灣身心靈圈最熱門的自我探索工具之一。這篇帶你了解馬雅圖騰的基礎，以及如何找到靠譜的解讀師。",
    coverImage: "https://readdy.ai/api/search-image?query=Ancient%20Mayan%20calendar%20symbols%20and%20sacred%20geometry%20spiritual%20symbolism%20warm%20earth%20tones%20mystical%20atmosphere%20candles%20and%20crystals%20simple%20background%20photography&width=1200&height=630&seq=114&orientation=landscape",
    category: "馬雅圖騰",
    tags: ["馬雅圖騰", "身心靈", "自我探索", "馬雅曆法", "靈性", "懶人包"],
    author: {
      id: "author-3",
      name: "神秘客A",
      avatar: "https://readdy.ai/api/search-image?query=Asian%20woman%20with%20glasses%20portrait%20professional%20clean%20white%20background%20headshot&width=100&height=100&seq=203&orientation=squarish",
      bio: "資深美業神秘客，專精美容保養與外貌美化類評測，涵蓋美甲、美睫、霧眉、采耳、除毛與做臉等項目。擁有 5 年神秘客資歷，累積評測店家超過 120 間。善於從細節觀察服務品質，特別關注衛生標準與長期效果。堅持匿名探訪，幫助消費者找到最適合自己的美業選擇。",
    },
    publishedAt: "2025-03-15",
    readingTime: 7,
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>馬雅圖騰印記（又稱馬雅數命學、卓爾金曆）是馬雅文明留下的神聖曆法系統，以 20 個神聖圖騰與 13 個音調（1-13）組合，形成 260 個獨特的日子，循環記錄宇宙能量。每個人根據出生日期，都有屬於自己的主圖騰（又稱太陽印記）和引導圖騰。</p><p>近年台灣身心靈圈對馬雅系統的關注度大幅提升，解讀師的水準也參差不齊。這篇帶你了解基礎，幫你找到靠譜的解讀資源。</p>",
      },
      {
        _type: "featureList",
        _key: "totems",
        title: "20 個馬雅神聖圖騰",
        features: [
          { _key: "t1", icon: "ri-seedling-line", title: "鱷魚｜艾默納克（Imix）", description: "代表原始創造力與滋養，是宇宙之母的象徵，充滿保護本能" },
          { _key: "t2", icon: "ri-windy-line", title: "風｜伊克（Ik）", description: "代表溝通、呼吸與精神，是連接各界的橋樑，傳遞靈感與知識" },
          { _key: "t3", icon: "ri-sun-line", title: "太陽｜阿勞（Ahau）", description: "代表啟蒙、全然的愛與圓滿，是 20 個圖騰的最後也是最完整的" },
        ],
      },
      {
        _type: "cta",
        _key: "cta",
        title: "找你的馬雅圖騰解讀師",
        subtitle: "美好時光指南收錄台灣馬雅圖騰解讀師評比",
        buttonLabel: "查看解讀師評比",
        buttonHref: "#",
      },
    ],
    seo: {
      title: "馬雅圖騰印記懶人包｜了解你的生命密碼",
      description: "馬雅圖騰入門指南！20 個神聖圖騰介紹，教你如何找到自己的印記與靠譜的解讀師。",
      keywords: ["馬雅圖騰", "馬雅曆法", "馬雅數命學", "身心靈", "自我探索"],
    },
  },
  {
    id: "post-15",
    slug: "taipei-iwatens-top5",
    title: "台北岩盤浴推薦 TOP 5｜神秘客實測最排毒的溫熱療法",
    excerpt: "岩盤浴在台灣日漸風行，但品質差異極大。神秘客實際走訪台北 15 間岩盤浴場所，從石材品質、溫度控制、環境衛生三個維度評比，精選出 5 間最值得體驗的岩盤浴好店。",
    coverImage: "https://readdy.ai/api/search-image?query=Japanese%20iwatens%20hot%20stone%20bed%20spa%20room%20warm%20infrared%20healing%20stones%20therapeutic%20wellness%20environment%20calm%20minimalist%20interior%20simple%20background%20photography&width=1200&height=630&seq=115&orientation=landscape",
    category: "岩盤浴",
    tags: ["台北", "岩盤浴", "排毒", "溫熱療法", "放鬆療癒", "懶人包", "推薦"],
    author: {
      id: "author-1",
      name: "Amy編",
      avatar: "https://readdy.ai/api/search-image?query=Young%20asian%20woman%20portrait%20friendly%20smile%20clean%20white%20background%20lifestyle%20headshot&width=100&height=100&seq=201&orientation=squarish",
      bio: "資深美業神秘客，專精按摩與做臉/皮膚管理類評測。累積實地走訪超過 60 間按摩會館、SPA 與美容工作室，對於師傅手法、產品成分與療程效果有敏銳的判斷力。堅持匿名探訪，每次評比都親自體驗完整流程，確保資訊真實可靠。",
    },
    publishedAt: "2025-04-28",
    readingTime: 10,
    rating: 4.7,
    reviewCount: 189,
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>岩盤浴（日語：岩盤浴 / いわばんよく）源自日本，是一種躺在加熱的天然礦石板上，讓身體從遠紅外線輻射熱中吸收能量的溫熱療法。和一般汗蒸幕最大的差別是：岩盤浴是「乾式」，讓身體從深處由內向外排汗，溫度通常在 40-45 度（比汗蒸幕溫和），但效果更持久。</p><p>近年岩盤浴在台灣迅速流行，但品質參差不齊——有些店家只是普通加熱石板，沒有真正的遠紅外線效果。神秘客這次走訪台北 15 間岩盤浴場所，從石材品質、溫度控制穩定度、環境衛生三個維度嚴格評比。</p>",
      },
      {
        _type: "featureList",
        _key: "benefits",
        title: "岩盤浴的主要效果",
        features: [
          { _key: "b1", icon: "ri-drop-line", title: "深層排汗排毒", description: "遠紅外線能穿透皮膚 4-5 公分，促進深層組織排汗，帶走體內重金屬與代謝廢物" },
          { _key: "b2", icon: "ri-heart-pulse-line", title: "促進血液循環", description: "石板的持續溫熱促進微血管擴張，改善手腳冰冷、末梢循環不良" },
          { _key: "b3", icon: "ri-moon-line", title: "放鬆神經系統", description: "長時間躺臥 + 溫熱讓副交感神經活躍，改善睡眠品質、減少焦慮" },
        ],
      },
      {
        _type: "shopReview",
        _key: "reviews",
        title: "TOP 5 岩盤浴場所評比",
        shops: [
          {
            _key: "s1",
            name: "岩盤浴療癒中心",
            rating: 4.8,
            priceRange: "$800 - $2,500 /次",
            address: "台北市大安區敦化南路一段 200 號 B1",
            tags: ["遠紅外線", "天然礦石", "獨立包廂"],
            pros: ["使用日本進口天然礦石板，遠紅外線效果經儀器測試", "溫度控制穩定，全程維持 42-45 度不忽冷忽熱", "獨立包廂設計，隱私性極佳，可安心休息"],
            cons: ["單次價格偏高", "週末熱門時段較難預約"],
            recommendation: "追求高品質岩盤浴體驗的首選。建議選 60 分鐘療程，搭配療程後的草本茶點，整體感受完整。",
            image: "https://readdy.ai/api/search-image?query=Japanese%20iwatens%20hot%20stone%20bed%20spa%20room%20warm%20infrared%20healing%20stones%20therapeutic%20wellness%20environment%20calm%20minimalist%20interior%20simple%20background%20photography&width=600&height=400&seq=351&orientation=landscape",
            storeUrl: "https://www.google.com/maps/search/?api=1&query=岩盤浴療癒中心+台北+大安區",
          },
          {
            _key: "s2",
            name: "熱石養生會館",
            rating: 4.6,
            priceRange: "$600 - $1,800 /次",
            address: "台北市中山區南京東路三段 120 號 3F",
            tags: ["平價", "熱石療法", "岩盤浴"],
            pros: ["價格親民，學生和上班族都能負擔", "石板種類多樣，可依體質選擇不同礦石", "療程後提供養生茶飲和輕食"],
            cons: ["空間較小，包廂數量有限", "沒有淋浴設施，建議在家先洗好澡"],
            recommendation: "預算有限但想體驗岩盤浴的首選。黑曜石板療程對於改善手腳冰冷效果特別明顯。",
            image: "https://readdy.ai/api/search-image?query=Wellness%20spa%20with%20heated%20stone%20beds%20and%20warm%20ambient%20lighting%20cozy%20minimalist%20interior%20clean%20simple%20background%20photography&width=600&height=400&seq=352&orientation=landscape",
            storeUrl: "https://www.google.com/maps/search/?api=1&query=熱石養生會館+台北+中山區",
          },
        ],
      },
      {
        _type: "faq",
        _key: "faq",
        title: "岩盤浴常見問題",
        items: [
          { _key: "q1", question: "岩盤浴和汗蒸幕有什麼差別？", answer: "岩盤浴是「乾式」溫熱療法，躺在加熱的天然礦石板上，讓遠紅外線從體內深處加熱排汗。汗蒸幕則是「濕式」高溫蒸氣環境。岩盤浴溫度較低（40-45度）但排汗效果更深層。" },
          { _key: "q2", question: "多久做一次岩盤浴比較好？", answer: "一般建議每週 1-2 次。初次體驗建議從 30 分鐘開始，習慣後可延長到 60 分鐘。療程後多喝水，幫助代謝廢物排出。" },
          { _key: "q3", question: "哪些人不適合做岩盤浴？", answer: "孕婦、高血壓或心臟病患者、皮膚有開放性傷口者、以及酒後不建議。女性生理期可視個人狀況，建議先諮詢師傅。" },
        ],
      },
      {
        _type: "cta",
        _key: "cta",
        title: "看更多岩盤浴評比",
        subtitle: "神秘客實測台北岩盤浴場所，公正評比石材品質與環境衛生",
        buttonLabel: "查看岩盤浴評比",
        buttonHref: "#",
      },
    ],
    seo: {
      title: "台北岩盤浴推薦 TOP 5｜神秘客實測排毒溫熱療法",
      description: "台北岩盤浴評比！神秘客走訪 15 間場所，精選 5 間石材純正、溫度穩定的岩盤浴好店。附優缺點與 Google Maps 連結。",
      keywords: ["台北岩盤浴", "岩盤浴推薦", "排毒", "溫熱療法", "遠紅外線"],
    },
  },
];